import { Injectable, inject } from '@angular/core';

import { EmbeddableComponentsService, OnFeatureInit } from '@frontend/vanilla/core';

import { CloseMessageComponent } from './close-message.component';

@Injectable()
export class ContentMessagesBootstrapService implements OnFeatureInit {
    private embeddableComponentsService = inject(EmbeddableComponentsService);

    onFeatureInit() {
        this.embeddableComponentsService.registerEmbeddableComponent(CloseMessageComponent, 100);
    }
}
